import { useNavigate } from "react-router-dom";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import { useEffect, useRef, useState } from "react";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import MainHeading from "../../../components/comman/MainHeading";
import FilterComponent from "../../../components/comman/FilterComponent";
import CommonTable from "../../../components/comman/CommonTable";
import { MainFilterHandler } from "../../../components/comman/MainFilterHandler";
import ViewIcon from "../../../components/Icons/ViewIcon";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { formatAmount } from "../../../utility/CommonFunctions";
import { toast } from "react-toastify";
import BgBlurLoader from "../../../components/Loaders/BgBlurLoader";
import {
  saveActivePaymentAdvisoryTab,
  updateFiltersStates,
} from "../../../store/actions/UserActions";
import {
  Nav,
  NavItem,
  NavLink,
  Spinner,
  TabContent,
  Fade,
  TabPane,
} from "reactstrap";

export default function PaymentAdvisory() {
  const navigate = useNavigate();
  const timeoutId = useRef(null);
  const fileInputRef = useRef(null);
  const dispatch = useDispatch();
  const [isFirstYearChange, setIsFirstYearChange] = useState(true);
  const ActiveTab = useSelector(
    (state) => state?.root?.activePaymentAdvisoryTab
  );
  const filterDetails = useSelector((state) => state.root.filtersStates);
  const [pageStates, setPageStates] = useState({
    currentPage: 1,
    pageSize: 10,
    count: 0,
    totalPages: 0,
    tableLoader: false,
    paymentAdvisoryList: [],
    siteList: [],
    searchQuery: "",
    sortByDate: [
      moment().subtract(30, "days").format("YYYY-MM-DD"),
      moment().format("YYYY-MM-DD"),
    ],
    year: "",
    siteId: filterDetails?.siteId,
    companyList: [],
    companyId: "",
    downloadLoading: false,
    advisorytype: ActiveTab,
    companyIsLoading: false,
    isLoadingSite: false,
    isInitial: true,
  });
  const userDetails = useSelector((state) => state.root.userDetails);

  const [selectedRows, setSelectedRows] = useState([]);

  const handleSelectionChange = (checked, pageRowIds) => {
    if (checked) {
      const newSelected = [...new Set([...selectedRows, ...pageRowIds])];
      setSelectedRows(newSelected);
    } else {
      setSelectedRows([]);
    }
  };

  useEffect(() => {
    if (filterDetails?.year) {
      GetPaymentAdvisoryList(pageStates?.currentPage);
    }
    if (pageStates?.companyList?.length == 0) {
      GetCompanyList();
    }
  }, [
    filterDetails?.currentPage,
    pageStates?.searchQuery,
    filterDetails?.pageSize,
    filterDetails.sortByDate,
    filterDetails?.year,
    filterDetails?.siteId,
    filterDetails?.companyId,
    pageStates?.advisorytype,
    filterDetails?.orderBy,
    pageStates?.isInitial,
  ]);

  useEffect(() => {
    GetSiteList(filterDetails?.companyId);
  }, [filterDetails?.companyId]);

  const GetPaymentAdvisoryList = () => {
    let options = {
      method: "GET",
    };
    const filterData = {
      advisorytype: pageStates?.advisorytype,
      searchQuery: pageStates?.searchQuery,
      siteId: pageStates?.siteId,
      ...filterDetails,
    };
    let API = apiUrl.get_voucher + MainFilterHandler(filterData);
    setPageStates((prev) => ({
      ...prev,
      tableLoader: true,
      CustomerData: {},
    }));
    callApi(API, options).then((response) => {
      setPageStates((prev) => ({
        ...prev,
        tableLoader: false,
      }));
      if (response?.status === true) {
        const newData = response?.data?.voucher?.map((item) => ({
          ...item,
          recieverName:
            item?.Transactions?.[0]?.referenceName ||
            item?.Transactions?.[0]?.accountHolderName,
          paymentTicketType: item?.paymentticket?.type,
          transDate: moment(item?.Transactions?.[0]?.transactionDate).format(
            "DD-MM-YYYY"
          ),
          ptNumber: item?.paymentticket?.ticketNumber,
          stNumber: item?.salaryticket?.ticketNumber,
          siteNamePt: item?.paymentticket?.site?.name,
          siteNameSt: item?.salaryticket?.site?.name,
          amount: formatAmount(item?.Transactions?.[0]?.amount),
          createdBy: item?.Transactions?.[0]?.user?.name,
          paymentMethods: item?.Transactions[0]?.paymentMethod,
        }));
        setPageStates((prevStates) => ({
          ...prevStates,
          paymentAdvisoryList: newData,
        }));
        dispatch(
          updateFiltersStates({
            count: response?.data?.pageInfo?.total,
            totalPages: response?.data?.pageInfo?.totalPages,
          })
        );
      }
    });
  };

  const toggleTab = (tab) => {
    dispatch(saveActivePaymentAdvisoryTab(tab));
    setPageStates((prev) => ({
      ...prev,
      advisorytype: tab,
    }));
    dispatch(
      updateFiltersStates({
        currentPage: 1,
        companyId: "",
      })
    );
    setSelectedRows([]);
    if (pageStates?.siteList?.length == 0) {
      GetSiteList();
    }
  };

  const GetCompanyList = (inputValue) => {
    return new Promise((resolve) => {
      let API = `${apiUrl.get_company}${inputValue ? `?search=${inputValue}` : ""
        }`;
      let options = { method: "GET" };
      setPageStates((prev) => ({
        ...prev,
        companyIsLoading: true,
      }));
      callApi(API, options)
        .then((response) => {
          if (response?.status) {
            const formattedData = response?.data?.company.map((company) => ({
              value: company.id,
              label: company.name,
            }));

            setPageStates((prev) => ({
              ...prev,
              companyIsLoading: false,
              companyList: formattedData,
            }));
            resolve(formattedData);
          } else {
            resolve([]);
          }
        })
        .catch(() => {
          resolve([]);
        });
    });
  };

  const PageChangeHandler = (PageNo) => {
    if (PageNo > 0 && PageNo <= filterDetails?.totalPages) {
      dispatch(
        updateFiltersStates({
          currentPage: PageNo,
        })
      );
    }
  };

  const handleChangePageSize = (value) => {
    dispatch(
      updateFiltersStates({
        currentPage: 1,
        pageSize: value,
      })
    );
  };

  const handleSearchChange = (e) => {
    const { value } = e.target;
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
    timeoutId.current = setTimeout(() => {
      dispatch(updateFiltersStates({ currentPage: 1 }));
      setPageStates((prevState) => ({
        ...prevState,
        searchQuery: value,
      }));
    }, 300);
  };

  const HandleView = (data) => {
    navigate(RoutesLink.payment_advisory_detail + `/${data?.id}`);
  };

  const TableHeadingPT = [
    { value: "voucherNumber", label: "Payment Advisory NO." },
    { value: "ptNumber", label: "PT NO." },
    { value: "recieverName", label: "Reciever Name" },
    { value: "transDate", label: "Date" },
    { value: "siteNamePt", label: "Site" },
    { value: "createdBy", label: "Created By" },
    { value: "paymentTicketType", label: "Type" },
    { value: "paymentMethods", label: "Payment Method" },
    { value: "amount", label: "Amount" },
  ];
  const TableHeadingST = [
    { value: "voucherNumber", label: "Payment Advisory NO." },
    { value: "stNumber", label: "ST NO." },
    { value: "recieverName", label: "Reciever Name" },
    { value: "transDate", label: "Date" },
    { value: "siteNameSt", label: "Site" },
    { value: "createdBy", label: "Created By" },
    { value: "paymentMethods", label: "Payment Method" },
    { value: "amount", label: "Amount" },
  ];

  const ActionData = [
    {
      label: "view",
      className: "btn btn-link",
      icon: <ViewIcon />,
      title: "view",
      clickHandler: HandleView,
    },
  ];

  const dateChangeHandler = (Dates) => {
    let formattedDate = null;
    if (Dates && Dates.length === 2) {
      const startDate = new Date(
        Dates[0].getTime() - Dates[0].getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, 10);
      const endDate = new Date(
        Dates[1].getTime() - Dates[1].getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, 10);
      formattedDate = [startDate, endDate];
    }
    // console.log(formattedDate);
    if (formattedDate !== null) {
      dispatch(
        updateFiltersStates({
          sortByDate: formattedDate,
        })
      );
    } else {
      dispatch(
        updateFiltersStates({
          sortByDate: "",
        })
      );
    }
  };

  const GetSiteList = (companyId = null, searchQuery = null) => {
    return new Promise((resolve) => {
      let API =
        userDetails?.type === 2
          ? apiUrl.get_site +
          `?pageSize=${100}${companyId ? `&companyId=${companyId}` : ""}${searchQuery ? `&search=${searchQuery}` : ""
          }`
          : apiUrl.get_user_site +
          `?pageSize=${100}${companyId ? `&companyId=${companyId}` : ""}${searchQuery ? `&search=${searchQuery}` : ""
          }`;

      setPageStates((prev) => ({
        ...prev,
        isLoadingSite: true,
      }));

      callApi(API, { method: "GET" })
        .then((response) => {
          setPageStates((prev) => ({
            ...prev,
            isLoadingSite: false,
          }));

          if (response?.status) {
            const formattedData = response.data?.site?.map((item) => ({
              value: item?.site?.id || item.id,
              label: item?.site?.name || item.name,
            }));

            const isSitePresent = response.data?.site?.some((item) => {
              const id = item?.site?.id || item.id;
              return id == filterDetails?.siteId;
            });

            setPageStates((prev) => ({
              ...prev,
              ...(isSitePresent ? { isInitial: false } : { siteId: "" }),
              siteList: formattedData || [],
            }));

            resolve(formattedData);
          } else {
            resolve([]);
          }
        })
        .catch(() => {
          setPageStates((prev) => ({
            ...prev,
            isLoadingSite: false,
          }));
          resolve([]);
        });
    });
  };

  const sortList = {
    site: pageStates?.siteList,
    isShow: "show",
    companyList: pageStates?.companyList,
  };

  const handleSortData = (data, type) => {
    setPageStates((prevState) => ({
      ...prevState,
      ...(type === "site" && { siteId: data?.site }),
      ...(type === "companyId" && { companyId: data?.companyId }),
      ...(type == "companyId" && {
        siteId: "",
      }),
    }));
    dispatch(
      updateFiltersStates({
        ...(type === "site" && { siteId: data?.site }),
        ...(type == "companyId" && { companyId: data?.companyId, siteId: "" }),
      })
    );
  };

  const handleYearChange = (selectedYear) => {
    dispatch(
      updateFiltersStates({
        year: selectedYear,
        sortByDate: isFirstYearChange ? filterDetails.sortByDate : [],
      })
    );

    if (isFirstYearChange) {
      setIsFirstYearChange(false);
    }
  };

  const HandleDownloadPA = async (data) => {
    const submitData = {
      voucherId: selectedRows,
    };
    let options = {
      method: "POST",
      data: submitData,
    };

    const API = apiUrl?.generate_payment_advisory;
    try {
      setPageStates((pre) => ({
        ...pre,
        downloadLoading: true,
      }));
      const response = await callApi(API, options);
      setPageStates((pre) => ({
        ...pre,
        downloadLoading: false,
      }));
      if (response?.status === true && response?.data) {
        const fileUrl = response?.data;
        const fileName = `Payment Advisory.pdf`;

        const fileResponse = await fetch(fileUrl);

        if (!fileResponse.ok) {
          throw new Error("Failed to fetch the file for download");
        }

        const blob = await fileResponse.blob();
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url); // clean up
        setSelectedRows([]);
      } else {
        toast.error(response?.message || "Failed to fetch file URL");
      }
    } catch (err) {
      console.error(err);
      toast.error("Download failed. Please try again.");
    }
  };

  const orderByHandler = (e) => {
    dispatch(
      updateFiltersStates({
        orderBy: e.target.value,
      })
    );
  };

  const orderByList = [
    { value: "", name: "Newest" },
    { value: "asc", name: "Oldest" },
  ];

  const HandleDownloadSample = async () => {
    const API = apiUrl?.download_sample_voucher_excel;
    try {
      setPageStates((pre) => ({
        ...pre,
        downloadLoading: true,
      }));
      const response = await callApi(API, { method: "GET" });
      setPageStates((pre) => ({
        ...pre,
        downloadLoading: false,
      }));
      if (response?.status === true && response?.data) {
        const fileUrl = response?.data;
        const fileName = `Sample_Excel.xlsx`;

        const fileResponse = await fetch(fileUrl);
        if (!fileResponse.ok) {
          throw new Error("Failed to fetch the file for download");
        }

        const blob = await fileResponse.blob();
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } else {
        toast.error(response?.message || "Failed to fetch sample file URL");
      }
    } catch (err) {
      console.error(err);
      setPageStates((pre) => ({
        ...pre,
        downloadLoading: false,
      }));
      toast.error("Download failed. Please try again.");
    }

  }

  const HandleUploadExel = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.size > 6 * 1024 * 1024) {
      toast.error("File size must be less than 6MB");
      e.target.value = "";
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    const API = apiUrl.create_bulk_vouchers;
    try {
      setPageStates((pre) => ({
        ...pre,
        downloadLoading: true,
      }));

      const response = await callApi(API, {
        method: "POST",
        form_data: formData,
      });

      setPageStates((pre) => ({
        ...pre,
        downloadLoading: false,
      }));

      if (response?.status === true) {
        toast.success(response?.message || "File uploaded successfully and data Updated");
        GetPaymentAdvisoryList();
      } else if (response?.status === false && Array.isArray(response?.data)) {
        toast.error(
          <div className="text-start">
            <strong>Validation Failed</strong>
            <ul className="mb-0 ps-3 text-start">
              {response?.data?.map((err, index) => (
                <li key={index} className="text-start">
                  Row {err.row}: {err.error}
                </li>
              ))}
            </ul>
          </div>,
          { autoClose: false }
        );
      } else {
        toast.error(response?.message || "Failed to upload file");
      }
    } catch (err) {
      console.error(err);
      setPageStates((pre) => ({
        ...pre,
        downloadLoading: false,
      }));
      toast.error("Upload failed. Please try again.");
    } finally {
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    }
  };

  return (
    <>
      {pageStates?.downloadLoading && BgBlurLoader()}
      <div className="content">
        <MainHeading
          title={"Payment Advisory"}
          dateChangeHandler={dateChangeHandler}
          handleYearChange={handleYearChange}
        />
        <div className="d-flex justify-content-between">

          <Nav tabs className="nav nav-tabs border-0 mb-4">
            <NavItem className="nav-item">
              <NavLink
                className={
                  ActiveTab === "paymentTicket"
                    ? "btn btn-outline-primary px-5 rounded-start-2 rounded-end-0 border-end-2 border-start-2 active"
                    : "btn btn-outline-primary px-5 rounded-start-2 rounded-end-0 border-end-2 border-start-2"
                }
                style={{ cursor: "pointer" }}
                onClick={() => toggleTab("paymentTicket")}
              >
                Payment Ticket
              </NavLink>
            </NavItem>
            <NavItem className="nav-item ">
              <NavLink
                className={
                  ActiveTab === "salaryTicket"
                    ? "btn btn-outline-primary px-5 rounded-start-0 rounded-end-2 border-end-2 border-start-0 active"
                    : "btn btn-outline-primary px-5 rounded-start-0 rounded-end-2 border-end-2 border-start-0"
                }
                style={{ cursor: "pointer" }}
                onClick={() => toggleTab("salaryTicket")}
              >
                Salary Ticket
              </NavLink>
            </NavItem>
          </Nav>
          {ActiveTab === "paymentTicket" &&
            <div>
              <button className="btn btn-outline-primary mx-1" onClick={HandleDownloadSample}>Download Sample</button>
              <button className="btn btn-outline-primary mx-1" onClick={HandleUploadExel}>Upload Excel</button>
              <input
                type="file"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={handleFileChange}
                accept=".xlsx, .xls"
              />
            </div>}
        </div>
        {selectedRows?.length > 0 && (
          <div className="alert alert-info d-flex justify-content-center align-items-center p-2 px-3 rounded-3">
            <div className="d-flex align-items-center gap-2">
              <i className="bi bi-check-circle-fill text-success fs-5"></i>
              <span className=" fs-5">
                Selected <strong>{selectedRows.length}</strong> of Total{" "}
                <strong>{filterDetails?.count}</strong> Payment Advisory to
                Download
              </span>
            </div>
          </div>
        )}

        <TabContent activeTab={ActiveTab}>
          <TabPane tabId={"paymentTicket"}>
            <Fade in={ActiveTab === "paymentTicket"} timeout={200}>
              <div className="card mb-4">
                <div className="card-body">
                  <FilterComponent
                    handleSearch={handleSearchChange}
                    searchPlaceHolder={"Search By Payment Advisory No."}
                    filterArray={sortList}
                    handleData={handleSortData}
                    pageStates={pageStates}
                    handleDownloadPA={
                      selectedRows?.length > 0 ? HandleDownloadPA : ""
                    }
                    orderByHandler={orderByHandler}
                    orderByList={orderByList}
                    getSite={GetSiteList}
                    getCompany={GetCompanyList}
                  />
                  <CommonTable
                    TableHeading={TableHeadingPT}
                    TableData={pageStates?.paymentAdvisoryList}
                    ActionData={ActionData}
                    currentPage={filterDetails?.currentPage}
                    PageChangeHandler={PageChangeHandler}
                    isLoading={pageStates?.tableLoader}
                    totalPages={filterDetails?.totalPages}
                    count={filterDetails?.count}
                    handleChangePageSize={handleChangePageSize}
                    pageSize={filterDetails?.pageSize}
                    selectedRows={selectedRows}
                    setSelectedRows={setSelectedRows}
                    onSelectionChange={handleSelectionChange}
                    rowKey="id"
                  />
                </div>
              </div>
            </Fade>
          </TabPane>
          <TabPane tabId={"salaryTicket"}>
            <Fade in={ActiveTab === "salaryTicket"} timeout={200}>
              <div className="card mb-4">
                <div className="card-body">
                  <FilterComponent
                    handleSearch={handleSearchChange}
                    searchPlaceHolder={"Search By Payment Advisory No."}
                    filterArray={sortList}
                    handleData={handleSortData}
                    pageStates={pageStates}
                    handleDownloadPA={
                      selectedRows?.length > 0 ? HandleDownloadPA : ""
                    }
                    orderByHandler={orderByHandler}
                    orderByList={orderByList}
                    getSite={GetSiteList}
                    getCompany={GetCompanyList}
                  />
                  <CommonTable
                    TableHeading={TableHeadingST}
                    TableData={pageStates?.paymentAdvisoryList}
                    ActionData={ActionData}
                    currentPage={filterDetails?.currentPage}
                    PageChangeHandler={PageChangeHandler}
                    isLoading={pageStates?.tableLoader}
                    totalPages={filterDetails?.totalPages}
                    count={filterDetails?.count}
                    handleChangePageSize={handleChangePageSize}
                    pageSize={filterDetails?.pageSize}
                    selectedRows={selectedRows}
                    setSelectedRows={setSelectedRows}
                    onSelectionChange={handleSelectionChange}
                    rowKey="id"
                  />
                </div>
              </div>
            </Fade>
          </TabPane>
        </TabContent>
      </div>
    </>
  );
}
